import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Grid,
  GridItem,
  VStack,
  Button,
  Text,
  useToast,
  Spinner,
  Flex,
} from "@chakra-ui/react";
import DynamicFormContainer from "components/CommonForm/DynamicFormContainer";
import ProfileCard from "components/CommonForm/ProfileCard";
import { driversApiAction } from "stores/redux/apiSlices/driverApi/driverApiSlice";
import { toastActions } from "stores/redux/slices/toastSlice";

const AddDriver = ({ driverData, onAddDriverStatus }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const [createDriverApi] = driversApiAction.addDriverApi();
  const [updateDriverApi] = driversApiAction.updateDriverApi();

  const [formData, setFormData] = useState({
    driverName: driverData?.name || "",
    email: driverData?.email || "",
    phoneNumber: driverData?.mobile || "",
    assignedClients: driverData?.clientNames || "",
  });
  const isEdit = !!driverData?.id;

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [status, setStatus] = useState(() => {
    const raw = driverData?.status;
    if (typeof raw === "boolean") return raw;
    if (typeof raw === "string") return raw.toLowerCase() === "true";
    if (typeof raw === "number") return raw === 1;
    return false;
  });

  const handleToggle = () => {
    setStatus((prev) => !prev);
  };

  useEffect(() => {
    if (driverData?.status !== undefined) {
      const raw = driverData.status;
      const parsedStatus =
        typeof raw === "boolean"
          ? raw
          : typeof raw === "string"
          ? raw.toLowerCase() === "true"
          : typeof raw === "number"
          ? raw === 1
          : false;
      setStatus(parsedStatus);
    }
  }, [driverData]);

  useEffect(() => {
    if (driverData) {
      setFormData((prevData) => ({
        ...prevData,
        driverName: driverData.name || prevData.driverName,
        email: driverData.email || prevData.email,
        phoneNumber: driverData.mobile || prevData.phoneNumber,
        assignedClients: driverData.clientNames || prevData.clientNames,
      }));
    }
  }, [driverData]);

  const validateForm = () => {
    let newErrors = {};
    formConfig[0].fields.forEach((field) => {
      if (field.required && !formData[field.name]) {
        newErrors[field.name] = "Αυτό το πεδίο είναι υποχρεωτικό";
      }
      if (
        field.validation === "email" &&
        formData[field.name] &&
        !/\S+@\S+\.\S+/.test(formData[field.name])
      ) {
        newErrors[field.name] = "Μη έγκυρη διεύθυνση email";
      }
      if (
        field.validation === "phone" &&
        formData[field.name] &&
        !/^\+30\s\d{3}\s\d{4}\s\d{3}$/.test(formData[field.name])
      ) {
        newErrors[field.name] = "Η μορφή πρέπει να είναι: +30 698 5554 444";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
 const rawMobile = formData.phoneNumber.replace(/\D/g, "").replace(/^30/, "");
    const payload = {
      role: "DRIVER",
      name: formData.driverName,
      email: formData.email,
      mobile: formData.phoneNumber,
      //  mobile: rawMobile,
    };
   




    const onSuccess = (response) => {
      toast({
        title: "Success",
        description: response.message || "Οδηγός δημιουργήθηκε με επιτυχία",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      onAddDriverStatus?.(response.success);
    };

    const onError = (error) => {
      toast({
        title: "Error",
        description: error.data?.message || "Αποτυχία δημιουργίας οδηγού",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    };

    const finalize = () => setIsSubmitting(false);

    if (driverData?.id) {
      updateDriverApi({ id: driverData.id, isActive: status, ...payload })
        .unwrap()
        .then(onSuccess)
        .catch(onError)
        .finally(finalize);
    } else {
      createDriverApi(payload)
        .unwrap()
        .then(onSuccess)
        .catch(onError)
        .finally(finalize);
    }
  };

  const formConfig = [
    {
      id: "driverInfo",
      title: "Πληροφορίες Οδηγού",
      fields: [
        {
          name: "driverName",
          label: "Όνομα Οδηγού",
          type: "text",
          required: true,
          gridSize: 6,
        },
        {
          name: "email",
          label: "Email",
          type: "email",
          required: true,
          gridSize: 6,
          validation: "email",
        },
        {
          name: "phoneNumber",
          label: "Αριθμός Τηλεφώνου",
          type: "text", // NOT "number"
          required: true,
          gridSize: 6,
          validation: "phone",
        },

        ...(isEdit
          ? [
              {
                name: "assignedClients",
                label: "Πελάτες",
                type: "textarea",
                required: false,
                gridSize: 6,
                editable: false,
              },
            ]
          : []),
      ],
    },
  ];

  return (
    <Box mt={24}>
      {isEdit && (
        <ProfileCard
          name={formData.driverName}
          email={formData.email}
          profileImage={formData.clientImage || ""}
          isActive={status}
          onToggle={handleToggle}
        />
      )}

      <Grid mt={4} templateColumns="1fr" gap={6} alignItems="start">
        <GridItem>
          <VStack spacing={6} align="stretch">
            <DynamicFormContainer
              key={formConfig[0].id}
              title={formConfig[0].title}
              cardData={formConfig[0]}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
            />
          </VStack>
        </GridItem>
      </Grid>

      {Object.keys(errors).length > 0 && (
        <Text color="red.500" mt={4}>
          Παρακαλώ διορθώστε τα σφάλματα πριν την υποβολή.
        </Text>
      )}

      <Button
        mt={6}
        variant="no-hover"
        bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
        minW="125px"
        h="35px"
        color="#fff"
        fontSize="xs"
        fontWeight="bold"
        alignSelf={{ sm: "flex-start", lg: null }}
        mb={{ sm: "12px", md: "0px" }}
        onClick={handleSubmit}
        isDisabled={isSubmitting}
      >
        {isSubmitting ? (
          <Spinner size="sm" color="white" />
        ) : isEdit ? (
          "Ενημέρωση Οδηγού"
        ) : (
          "Προσθήκη Οδηγού"
        )}
      </Button>
    </Box>
  );
};

export default AddDriver;
